import {
  ImpactShopBasketProduct,
  Currency,
  ImpactShopProductPrice,
  normaliseString,
} from "@ecologi/shared";

export const findProduct = (
  basket: ImpactShopBasketProduct[],
  productToFind: ImpactShopBasketProduct
) =>
  basket.find(
    (product) =>
      product.id === productToFind.id &&
      normaliseString(product.fundedBy) ===
        normaliseString(productToFind.fundedBy) &&
      normaliseString(product.recipientEmail ?? "") ===
        normaliseString(productToFind.recipientEmail ?? "")
  );

/**
 * Return total quantity of a specific product within the basket
 */
export const getTotalProductQuantity = (
  basket: ImpactShopBasketProduct[],
  productToFind: ImpactShopBasketProduct
) =>
  basket.reduce(
    (acc, product) =>
      product.id === productToFind.id ? acc + product.quantity : acc,
    0
  );

export const getProductPrice = (
  prices: ImpactShopProductPrice[],
  currency: Currency
) => prices.find((price) => price.currency === currency).amount;

export const updateProductAttribute = (
  basket: ImpactShopBasketProduct[],
  productToUpdate: ImpactShopBasketProduct,
  attribute:
    | { amount: number; overwrite: boolean }
    | { fundedBy: string }
    | { recipientEmail: string | null }
) => [
  ...basket.map((product) => {
    if (product.basketItemId !== productToUpdate.basketItemId) {
      return product;
    }

    const updatedProduct = { ...product };

    if ("amount" in attribute) {
      updatedProduct.quantity = attribute.overwrite
        ? attribute.amount
        : product.quantity + attribute.amount;
    }

    if ("fundedBy" in attribute) {
      updatedProduct.fundedBy = attribute.fundedBy;
    }

    if ("recipientEmail" in attribute) {
      if (attribute.recipientEmail === null) {
        delete updatedProduct.recipientEmail;
      } else {
        updatedProduct.recipientEmail = attribute.recipientEmail;
      }
    }

    return updatedProduct;
  }),
];
